module.exports = __webpack_public_path__ + "img/g8.7894c14b.png";